// Animals (Horse, Dogs, Pets)
import Bone from "../assets/svg/clipart/animals-horse-dogs-pets/bone.svg";
import DashingDog from "../assets/svg/clipart/animals-horse-dogs-pets/dashing-dog.svg";
import DogBowl from "../assets/svg/clipart/animals-horse-dogs-pets/dog-bowl.svg";
import DogFace from "../assets/svg/clipart/animals-horse-dogs-pets/dog-face.svg";
import DogSitting from "../assets/svg/clipart/animals-horse-dogs-pets/dog-sitting.svg";
import HorseGallop from "../assets/svg/clipart/animals-horse-dogs-pets/horse-gallop.svg";
import HorseRider from "../assets/svg/clipart/animals-horse-dogs-pets/horse-rider.svg";
import HorseStanding from "../assets/svg/clipart/animals-horse-dogs-pets/horse-standing.svg";
import HorsesHeadMane from "../assets/svg/clipart/animals-horse-dogs-pets/horses-head-mane.svg";
import HorsesHeadNeat from "../assets/svg/clipart/animals-horse-dogs-pets/horses-head-neat.svg";
import HorsesHead from "../assets/svg/clipart/animals-horse-dogs-pets/horses-head.svg";
import Horseshoe from "../assets/svg/clipart/animals-horse-dogs-pets/horseshoe.svg";
import Pawprint from "../assets/svg/clipart/animals-horse-dogs-pets/pawprint.svg";
import Showjumper from "../assets/svg/clipart/animals-horse-dogs-pets/showjumper.svg";
import Unicorn from "../assets/svg/clipart/animals-horse-dogs-pets/unicorn.svg";

// Baby
import BabyBottle from "../assets/svg/clipart/baby/baby-bottle.svg";
import BabyFeet from "../assets/svg/clipart/baby/baby-feet.svg";
import Pram from "../assets/svg/clipart/baby/pram.svg";
import RockingHorse from "../assets/svg/clipart/baby/rocking-horse.svg";
import TeddyFace from "../assets/svg/clipart/baby/teddy-face.svg";

// Christmas
import Bow from "../assets/svg/clipart/christmas/bow.svg";
import Gingerbread from "../assets/svg/clipart/christmas/gingerbread-test-1.svg";
import HollyBerries from "../assets/svg/clipart/christmas/holly-berries.svg";
import Present from "../assets/svg/clipart/christmas/present.svg";
import SantaFace from "../assets/svg/clipart/christmas/santa-face.svg";
import Snowflake from "../assets/svg/clipart/christmas/snowflake.svg";
import SnowmanFace from "../assets/svg/clipart/christmas/snowman-face.svg";
import Stocking from "../assets/svg/clipart/christmas/stocking.svg";
import XmasTree from "../assets/svg/clipart/christmas/xmas-tree.svg";

// Crowns
import BeautyQueen from "../assets/svg/clipart/crowns/beauty-queen.svg";
import DutchessCrown from "../assets/svg/clipart/crowns/dutchess-crown.svg";
import KingCrown from "../assets/svg/clipart/crowns/king-crown.svg";
import PrinceCrown from "../assets/svg/clipart/crowns/prince-crown.svg";
import PrincessCrown from "../assets/svg/clipart/crowns/princess-crown.svg";
import QueensCrown from "../assets/svg/clipart/crowns/queens-crown.svg";

//Emoji
import OmgPoop from "../assets/svg/clipart/emoji/OMG-poop.svg";
import CoolEmoji from "../assets/svg/clipart/emoji/cool-emoji.svg";
import HappyPoop from "../assets/svg/clipart/emoji/happy-poop.svg";
import LolEmoji from "../assets/svg/clipart/emoji/lol-emoji.svg";
import LoveEmoji from "../assets/svg/clipart/emoji/love-emoji.svg";
import LoveEyeEmoji from "../assets/svg/clipart/emoji/love-eye-emoji.svg";
import LovePoop from "../assets/svg/clipart/emoji/love-poop.svg";
import NaughtyDevilEmoji from "../assets/svg/clipart/emoji/naughty-devil-emoji.svg";
import SillyEmoji from "../assets/svg/clipart/emoji/silly-emoji.svg";
import SmileEmoji from "../assets/svg/clipart/emoji/smile-emoji.svg";
import WinkEmoji from "../assets/svg/clipart/emoji/wink-emoji.svg";
import WowEmoji from "../assets/svg/clipart/emoji/wow-emoji-1.svg";

// Halloween
import Bat from "../assets/svg/clipart/halloween/bat.svg";
import HauntedHouse from "../assets/svg/clipart/halloween/haunted-house.svg";
import Pumpkin from "../assets/svg/clipart/halloween/pumpkin.svg";
import SkullFunny from "../assets/svg/clipart/halloween/skull-funny.svg";
import Spider from "../assets/svg/clipart/halloween/spider.svg";
import WitchHat from "../assets/svg/clipart/halloween/witch-hat.svg";

// Clipart
import ThreeHearts from "../assets/svg/clipart/hearts/3-hearts-1.svg";
import Heart from "../assets/svg/clipart/hearts/heart-1.svg";
import LeaningHeart from "../assets/svg/clipart/hearts/leaning-heart-1.svg";
import ModernHearts from "../assets/svg/clipart/hearts/modern-hearts-1-1.svg";
import SwooshHeart from "../assets/svg/clipart/hearts/swoosh-heart-1.svg";
import TwoLoveHearts from "../assets/svg/clipart/hearts/two-love-hearts-1.svg";

// Holidays
import Airplane from "../assets/svg/clipart/holidays/airplane.svg";
import Camera from "../assets/svg/clipart/holidays/camera.svg";
import CruiseShip from "../assets/svg/clipart/holidays/cruise-ship.svg";
import EiffelTower from "../assets/svg/clipart/holidays/eiffel-tower.svg";
import Liberty from "../assets/svg/clipart/holidays/liberty.svg";
import London from "../assets/svg/clipart/holidays/london.svg";
import PalmTree from "../assets/svg/clipart/holidays/palmtree.svg";
import Sunset from "../assets/svg/clipart/holidays/sunset.svg";
import Sydney from "../assets/svg/clipart/holidays/sydney.svg";

// Party and Fun
import LPlate from "../assets/svg/clipart/party-and-fun/L-plate.svg";
import Anchor from "../assets/svg/clipart/party-and-fun/ancor.svg";
import Balloons1 from "../assets/svg/clipart/party-and-fun/balloons-1.svg";
import BalloonsStars from "../assets/svg/clipart/party-and-fun/balloons-stars.svg";
import Beer from "../assets/svg/clipart/party-and-fun/beer.svg";
import BigLips from "../assets/svg/clipart/party-and-fun/big-lips.svg";
import Bikini from "../assets/svg/clipart/party-and-fun/bikini.svg";
import Bottle from "../assets/svg/clipart/party-and-fun/bottle.svg";
import Butterfly from "../assets/svg/clipart/party-and-fun/butterfly.svg";
import CocktailGlass from "../assets/svg/clipart/party-and-fun/cocktail-glass.svg";
import CowboyHat from "../assets/svg/clipart/party-and-fun/cowboy-hat.svg";
import Daisy from "../assets/svg/clipart/party-and-fun/daisy.svg";
import Hen from "../assets/svg/clipart/party-and-fun/hen.svg";
import LipstickKiss from "../assets/svg/clipart/party-and-fun/lipstick-kiss.svg";
import Martini from "../assets/svg/clipart/party-and-fun/martini.svg";
import Masquerade from "../assets/svg/clipart/party-and-fun/masquerade.svg";
import PartyPopperAndBottle from "../assets/svg/clipart/party-and-fun/party-popper-and-bottle.svg";
import RingAndStars from "../assets/svg/clipart/party-and-fun/ring-and-stars.svg";
import SexyLady from "../assets/svg/clipart/party-and-fun/sexy-lady.svg";
import Shoe from "../assets/svg/clipart/party-and-fun/shoe.svg";
import Star1 from "../assets/svg/clipart/party-and-fun/star-1.svg";
import ThreeStars from "../assets/svg/clipart/party-and-fun/three-stars.svg";
import TwoGlasses from "../assets/svg/clipart/party-and-fun/two-glasses.svg";
import TwoStars from "../assets/svg/clipart/party-and-fun/two-stars.svg";
import Wand from "../assets/svg/clipart/party-and-fun/wand.svg";

// Patriotic
import EnglishRose from "../assets/svg/clipart/patriotic/english-rose.svg";
import Shamrock from "../assets/svg/clipart/patriotic/shamrock.svg";
import StAndrews from "../assets/svg/clipart/patriotic/st-andrews.svg";
import Thistle from "../assets/svg/clipart/patriotic/thistle.svg";
import UnionJack from "../assets/svg/clipart/patriotic/union-jack.svg";
import WelshDragon from "../assets/svg/clipart/patriotic/welsh-dragon.svg";

// Religious
import Buddhism from "../assets/svg/clipart/religious/buddhism.svg";
import Christianity from "../assets/svg/clipart/religious/christianity.svg";
import Dove from "../assets/svg/clipart/religious/dove.svg";
import Eye from "../assets/svg/clipart/religious/eye.svg";
import Hinduism from "../assets/svg/clipart/religious/hinduism.svg";
import Islam from "../assets/svg/clipart/religious/islam.svg";
import JudaismMenorah from "../assets/svg/clipart/religious/judaism-menorah.svg";
import JudaismStar from "../assets/svg/clipart/religious/judaism-star.svg";
import Sikhism from "../assets/svg/clipart/religious/sikhism.svg";
import Taoism1 from "../assets/svg/clipart/religious/taoism-1.svg";

// School
import Art1 from "../assets/svg/clipart/school/art-1.svg";
import Graduation from "../assets/svg/clipart/school/graduation.svg";
import Reading from "../assets/svg/clipart/school/reading.svg";
import Recycling from "../assets/svg/clipart/school/recycling.svg";
import Smile from "../assets/svg/clipart/school/smile.svg";
import StarAward from "../assets/svg/clipart/school/star-award.svg";
import TrophyCup from "../assets/svg/clipart/school/trophy-cup.svg";
import TwoFlowers from "../assets/svg/clipart/school/two-flowers.svg";
import Writing from "../assets/svg/clipart/school/writing.svg";

// Sports and Hobbies
import BikeRide from "../assets/svg/clipart/sports-and-hobbies/bike-ride.svg";
import Bike from "../assets/svg/clipart/sports-and-hobbies/bike.svg";
import Cards from "../assets/svg/clipart/sports-and-hobbies/cards.svg";
import ChequeredFlag from "../assets/svg/clipart/sports-and-hobbies/chequered-flag.svg";
import CupCake from "../assets/svg/clipart/sports-and-hobbies/cup-cake.svg";
import Dance from "../assets/svg/clipart/sports-and-hobbies/dance.svg";
import Drama from "../assets/svg/clipart/sports-and-hobbies/drama.svg";
import Dumbell from "../assets/svg/clipart/sports-and-hobbies/dumbell.svg";
import Football from "../assets/svg/clipart/sports-and-hobbies/football.svg";
import GolfFlag from "../assets/svg/clipart/sports-and-hobbies/golf-flag.svg";
import Golfer from "../assets/svg/clipart/sports-and-hobbies/golfer.svg";
import KnifeFolk from "../assets/svg/clipart/sports-and-hobbies/knife-folk.svg";
import Medal from "../assets/svg/clipart/sports-and-hobbies/medal.svg";
import MusicNote from "../assets/svg/clipart/sports-and-hobbies/music-note.svg";
import Rosette from "../assets/svg/clipart/sports-and-hobbies/rosette.svg";
import Sailing from "../assets/svg/clipart/sports-and-hobbies/sailing.svg";
import TennisBall from "../assets/svg/clipart/sports-and-hobbies/tennis-ball.svg";
import TennisRacketBall from "../assets/svg/clipart/sports-and-hobbies/tennis-racket-ball.svg";
import Tenpin from "../assets/svg/clipart/sports-and-hobbies/tenpin.svg";
import Trophy from "../assets/svg/clipart/sports-and-hobbies/trophy.svg";

// Wedding
import Bells from "../assets/svg/clipart/wedding/bells.svg";
import Bouquet from "../assets/svg/clipart/wedding/bouquet.svg";
import Bride from "../assets/svg/clipart/wedding/bride.svg";
import Bubbly from "../assets/svg/clipart/wedding/bubbly.svg";
import GlassesToast from "../assets/svg/clipart/wedding/glasses-toast.svg";
import Groom from "../assets/svg/clipart/wedding/groom.svg";
import LoveLetter from "../assets/svg/clipart/wedding/love-letter.svg";
import TwinRings from "../assets/svg/clipart/wedding/twin-rings.svg";
import WeddingCake from "../assets/svg/clipart/wedding/wedding-cake.svg";
import WeddingDove from "../assets/svg/clipart/wedding/wedding-dove.svg";
import WeddingRing from "../assets/svg/clipart/wedding/wedding-ring.svg";

export const clipartData = [
  {
    name: "Animals (Horse, Dogs, Pets)",
    images: [
      { name: "Bone", image: Bone },
      { name: "Dashing Dog", image: DashingDog },
      { name: "Dog Bowl", image: DogBowl },
      { name: "Dog Face", image: DogFace },
      { name: "Dog Sitting", image: DogSitting },
      { name: "Horse Gallop", image: HorseGallop },
      { name: "Horse Rider", image: HorseRider },
      { name: "Horse Standing", image: HorseStanding },
      { name: "Horses Head Mane", image: HorsesHeadMane },
      { name: "Horses Head Neat", image: HorsesHeadNeat },
      { name: "Horses Head", image: HorsesHead },
      { name: "Horseshoe", image: Horseshoe },
      { name: "Pawprint", image: Pawprint },
      { name: "Showjumper", image: Showjumper },
      { name: "Unicorn", image: Unicorn },
    ],
  },
  {
    name: "Baby",
    images: [
      { name: "Baby Bottle", image: BabyBottle },
      { name: "Baby Feet", image: BabyFeet },
      { name: "Pram", image: Pram },
      { name: "Rocking Horse", image: RockingHorse },
      { name: "Teddy Face", image: TeddyFace },
    ],
  },
  {
    name: "Christmas",
    images: [
      { name: "Bow", image: Bow },
      { name: "Gingerbread", image: Gingerbread },
      { name: "Holly Berries", image: HollyBerries },
      { name: "Present", image: Present },
      { name: "Santa Face", image: SantaFace },
      { name: "Snowflake", image: Snowflake },
      { name: "Snowman Face", image: SnowmanFace },
      { name: "Stocking", image: Stocking },
      { name: "Xmas Tree", image: XmasTree },
    ],
  },
  {
    name: "Crowns",
    images: [
      { name: "Beauty Queen", image: BeautyQueen },
      { name: "Dutchess Crown", image: DutchessCrown },
      { name: "King Crown", image: KingCrown },
      { name: "Prince Crown", image: PrinceCrown },
      { name: "Princess Crown", image: PrincessCrown },
      { name: "Queens Crown", image: QueensCrown },
    ],
  },
  {
    name: "Emoji",
    images: [
      { name: "OMG Poop", image: OmgPoop },
      { name: "Cool Emoji", image: CoolEmoji },
      { name: "Happy Poop", image: HappyPoop },
      { name: "Lol Emoji", image: LolEmoji },
      { name: "Love Emoji", image: LoveEmoji },
      { name: "Love Eye Emoji", image: LoveEyeEmoji },
      { name: "Love Poop", image: LovePoop },
      { name: "Naughty Devil Emoji", image: NaughtyDevilEmoji },
      { name: "Silly Emoji", image: SillyEmoji },
      { name: "Smile Emoji", image: SmileEmoji },
      { name: "Wink Emoji", image: WinkEmoji },
      { name: "Wow Emoji", image: WowEmoji },
    ],
  },
  // Halloween Category
  {
    name: "Halloween",
    images: [
      { name: "Bat", image: Bat },
      { name: "Haunted House", image: HauntedHouse },
      { name: "Pumpkin", image: Pumpkin },
      { name: "Skull Funny", image: SkullFunny },
      { name: "Spider", image: Spider },
      { name: "Witch Hat", image: WitchHat },
    ],
  },
  // Hearts Category
  {
    name: "Hearts",
    images: [
      { name: "Three Hearts", image: ThreeHearts },
      { name: "Heart", image: Heart },
      { name: "Leaning Heart", image: LeaningHeart },
      { name: "Modern Hearts", image: ModernHearts },
      { name: "Swoosh Heart", image: SwooshHeart },
      { name: "Two Love Hearts", image: TwoLoveHearts },
    ],
  },
  // Holidays Category
  {
    name: "Holidays",
    images: [
      { name: "Airplane", image: Airplane },
      { name: "Camera", image: Camera },
      { name: "Cruise Ship", image: CruiseShip },
      { name: "Eiffel Tower", image: EiffelTower },
      { name: "Statue of Liberty", image: Liberty },
      { name: "London", image: London },
      { name: "Palm Tree", image: PalmTree },
      { name: "Sunset", image: Sunset },
      { name: "Sydney", image: Sydney },
    ],
  },
  {
    name: "Party and Fun",
    images: [
      { name: "L Plate", image: LPlate },
      { name: "Anchor", image: Anchor },
      { name: "Balloons 1", image: Balloons1 },
      { name: "Balloons Stars", image: BalloonsStars },
      { name: "Beer", image: Beer },
      { name: "Big Lips", image: BigLips },
      { name: "Bikini", image: Bikini },
      { name: "Bottle", image: Bottle },
      { name: "Butterfly", image: Butterfly },
      { name: "Cocktail Glass", image: CocktailGlass },
      { name: "Cowboy Hat", image: CowboyHat },
      { name: "Daisy", image: Daisy },
      { name: "Hen", image: Hen },
      { name: "Lipstick Kiss", image: LipstickKiss },
      { name: "Martini", image: Martini },
      { name: "Masquerade", image: Masquerade },
      { name: "Party Popper and Bottle", image: PartyPopperAndBottle },
      { name: "Ring and Stars", image: RingAndStars },
      { name: "Sexy Lady", image: SexyLady },
      { name: "Shoe", image: Shoe },
      { name: "Star 1", image: Star1 },
      { name: "Three Stars", image: ThreeStars },
      { name: "Two Glasses", image: TwoGlasses },
      { name: "Two Stars", image: TwoStars },
      { name: "Wand", image: Wand },
    ],
  },
  // Patriotic Category
  {
    name: "Patriotic",
    images: [
      { name: "English Rose", image: EnglishRose },
      { name: "Shamrock", image: Shamrock },
      { name: "St Andrews", image: StAndrews },
      { name: "Thistle", image: Thistle },
      { name: "Union Jack", image: UnionJack },
      { name: "Welsh Dragon", image: WelshDragon },
    ],
  },
  // Religious Category
  {
    name: "Religious",
    images: [
      { name: "Buddhism", image: Buddhism },
      { name: "Christianity", image: Christianity },
      { name: "Dove", image: Dove },
      { name: "Eye", image: Eye },
      { name: "Hinduism", image: Hinduism },
      { name: "Islam", image: Islam },
      { name: "Judaism Menorah", image: JudaismMenorah },
      { name: "Judaism Star", image: JudaismStar },
      { name: "Sikhism", image: Sikhism },
      { name: "Taoism", image: Taoism1 },
    ],
  },
  // School Category
  {
    name: "School",
    images: [
      { name: "Art", image: Art1 },
      { name: "Graduation", image: Graduation },
      { name: "Reading", image: Reading },
      { name: "Recycling", image: Recycling },
      { name: "Smile", image: Smile },
      { name: "Star Award", image: StarAward },
      { name: "Trophy Cup", image: TrophyCup },
      { name: "Two Flowers", image: TwoFlowers },
      { name: "Writing", image: Writing },
    ],
  },
  // Sports and Hobbies Category
  {
    name: "Sports and Hobbies",
    images: [
      { name: "Bike Ride", image: BikeRide },
      { name: "Bike", image: Bike },
      { name: "Cards", image: Cards },
      { name: "Chequered Flag", image: ChequeredFlag },
      { name: "Cupcake", image: CupCake },
      { name: "Dance", image: Dance },
      { name: "Drama", image: Drama },
      { name: "Dumbell", image: Dumbell },
      { name: "Football", image: Football },
      { name: "Golf Flag", image: GolfFlag },
      { name: "Golfer", image: Golfer },
      { name: "Knife Folk", image: KnifeFolk },
      { name: "Medal", image: Medal },
      { name: "Music Note", image: MusicNote },
      { name: "Rosette", image: Rosette },
      { name: "Sailing", image: Sailing },
      { name: "Tennis Ball", image: TennisBall },
      { name: "Tennis Racket and Ball", image: TennisRacketBall },
      { name: "Tenpin", image: Tenpin },
      { name: "Trophy", image: Trophy },
    ],
  },
  // Wedding Category
  {
    name: "Wedding",
    images: [
      { name: "Bells", image: Bells },
      { name: "Bouquet", image: Bouquet },
      { name: "Bride", image: Bride },
      { name: "Bubbly", image: Bubbly },
      { name: "Glasses Toast", image: GlassesToast },
      { name: "Groom", image: Groom },
      { name: "Love Letter", image: LoveLetter },
      { name: "Twin Rings", image: TwinRings },
      { name: "Wedding Cake", image: WeddingCake },
      { name: "Wedding Dove", image: WeddingDove },
      { name: "Wedding Ring", image: WeddingRing },
    ],
  },
];
